import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import IconIndicator from '../texts/icon-indicator'
import Actions from '../buttons/actions'

const DataBlock = props => {
  const items = props.items
  const dataList = items.map((item, i) => (
    <li key={i}>
      <IconIndicator
        iconName={item.icon}
        hasLink={item.hasLink}
        linkUrl={item.linkUrl}
      >
        {item.text}
      </IconIndicator>
    </li>
  ))
  return (
    <div
      className={classNames({
        'data-block': true,
        [props.className]: props.className
      })}
    >
      {props.hasActions ? (
        <Actions onEdit={props.onEdit} onDelete={props.onDelete} />
      ) : null}
      <div className='data'>
        <p className='label'>{props.label}</p>
        <ul className='data-list'>{dataList}</ul>
      </div>
    </div>
  )
}

DataBlock.propTypes = {
  label: PropTypes.string,
  hasActions: PropTypes.bool,
  hasLink: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
}
export default DataBlock



// WEBPACK FOOTER //
// ./src/ui/texts/data-block.js